var _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBurger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 35,
    viewBox: "0 0 50 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 5,
    rx: 2.5,
    fill: "#FEFEFE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 15,
    width: 50,
    height: 5,
    rx: 2.5,
    fill: "#FEFEFE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 30,
    width: 50,
    height: 5,
    rx: 2.5,
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurger);
export default __webpack_public_path__ + "static/media/burger.169f576c1499cbeba13068db8a83bbec.svg";
export { ForwardRef as ReactComponent };